import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Lock } from "lucide-react";
import api, { formatApiError } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("pl_token", data.access_token);
      localStorage.setItem("pl_user", JSON.stringify(data.user));
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bone)] flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="text-sm text-[var(--slate)] hover:text-[var(--forest)]" data-testid="admin-back-link">
          ← Back to site
        </Link>
        <div className="card mt-4">
          <div className="w-12 h-12 rounded-xl bg-[var(--forest)] text-white flex items-center justify-center">
            <Lock size={20} />
          </div>
          <h1 className="font-display font-bold text-2xl mt-5">Admin sign in</h1>
          <p className="text-[var(--slate)] text-sm mt-1">For staff managing events and interest registrations.</p>

          <form onSubmit={onSubmit} className="mt-6 space-y-4" data-testid="admin-login-form">
            <div className="field">
              <label htmlFor="admin-email">Email</label>
              <input
                id="admin-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="admin-email-input"
              />
            </div>
            <div className="field">
              <label htmlFor="admin-password">Password</label>
              <input
                id="admin-password"
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="admin-password-input"
              />
            </div>
            {error && (
              <div className="text-sm text-red-700 bg-red-50 rounded-md px-3 py-2" data-testid="admin-login-error">
                {error}
              </div>
            )}
            <button type="submit" className="btn btn-primary w-full" disabled={loading} data-testid="admin-login-submit">
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
